module.exports = __webpack_public_path__ + "img/progress-bar.1a616ccc.png";